export default "__VITE_ASSET__D99U4z2G__"